export default __webpack_public_path__ + "static/media/recorte_5.d926d4d9.JPG";